import { useEffect, useState } from 'react';
import './BannerInfo.css'
import { useTimestampContext } from '../../context/timestampContext';

export const BannerInfo = () => {
    const {timestamp} = useTimestampContext();
    const [time, setTime] = useState<string | null>(null);

    function getLocalTime(timestamp: string) {
        const year = timestamp.substring(0, 4);
        const month = timestamp.substring(4, 6);
        const day = timestamp.substring(6, 8);
        const hour = timestamp.substring(8, 10);
        const minute = timestamp.substring(10, 12);
        const second = timestamp.substring(12, 14);
    
        const date = new Date(Date.UTC(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day),
            parseInt(hour),
            parseInt(minute),
            parseInt(second)
        ));

        return date.toLocaleTimeString('default', { 
            hour: '2-digit', 
            minute: '2-digit',
            hour12: true
        });
    }

    useEffect(() => {
        const localTime = getLocalTime(timestamp);
        if(localTime !== "Invalid Date"){
            setTime(localTime);
        }
    },[timestamp]);
    
    return(
        <>
            <div id="radar_play_info" className={'radar_play_info'} >
                <div id="current_radar_label" className={'current_radar_label'}>Radar {time}</div>
            </div>
        </>
    )
}
